<template>
    <div class="main_center">
        <div class="content">
            <div class="search-content">
                <div class="pageTitle" style="margin-top:-9px;">文件检测列表</div>
                <div class="centerSearch">
                    <el-input @keyup.enter.native="searchBtn" clearable placeholder="请输入" style="width: 500px;"
                        v-model="form.keywords">
                    </el-input>
                    <el-button @click="searchBtn('table')" class="rightSearchBtn" size="small" type="primary">搜索</el-button>
                    <el-button @click="moreSearchItem = true" class="height_four" icon="el-icon-arrow-down" size="mini"
                        type="text">更多搜索</el-button>
                    <el-divider direction="vertical"></el-divider>
                    <el-button @click="refresh" icon="el-icon-refresh" type="text"></el-button>
                </div>
            </div>


            <searchBox :dialogVisible.sync="moreSearchItem" @dialogCancle="dialogCancel" title="更多筛选">
                <div class="search-drawer">
                    <el-form :model="form" label-position="top" ref="form">
                        <el-form-item label="项目名称/编号：">
                            <el-input clearable placeholder="请输入内容搜索" v-model="form.keywords"></el-input>
                        </el-form-item>
                        <el-form-item label="分析状态：">
                            <el-select clearable v-model="form.detectStatusList" value-key="value" multiple>
                                <el-option :key="index" :label="item.name" :value="item.value"
                                    v-for="(item, index) in detectStatusOptions"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="分析时间：" prop='daterange' style="width:100%;">
                            <el-date-picker style="width: 100%" v-model="form.daterange" type="daterange"
                                format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                    <div class="search-drawer__footer">
                        <el-button @click="searchBtn('more')" size="small" type="primary">查询</el-button>
                        <el-button @click="refresh" plain size="small">重置</el-button>
                    </div>
                </div>
            </searchBox>
        </div>


        <div class="tableContent_" style="padding-top: 16px;">
            <div class="mainBtn" v-if="false">
                <el-button @click="addNew()" size="small" type="primary">重推</el-button>
                <el-button @click="refresh" size="small" type="primary" plain>刷新</el-button>
            </div>
            <el-table class="table-content" :data="tableData" :header-cell-style="this.$globalGrayTableHeaderStyle"
                v-loading="dataListLoading" ref="multipleTable" :height="tableMaxHeight" stripe border row-key="id">
                <el-table-column fixed label="序号" type="index" :index="indexMethod" width="50" align="center"
                    :show-overflow-tooltip='true'></el-table-column>
                <el-table-column label="标段编号" prop='bidSectionCode' align="left" min-width='180'
                    :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column label="标段名称" prop='bidSectionName' align="left" min-width='200'
                    :show-overflow-tooltip='true'>
                </el-table-column>
                <!-- <el-table-column label="推送状态" prop='pushStatusDesc' align="left" min-width='100'
                    :show-overflow-tooltip='true'></el-table-column> -->
                <el-table-column label="分析状态" prop='detectStatusDesc' header-align="center" align="center"
                    min-width='86' :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        <el-tag :type="{
                            1: '',
                            2: 'warning',
                            3: 'success',
                            4: 'danger',
                        }[scope.row.detectStatus]" size="small" :hit="false" effect="plain">
                            {{ scope.row.detectStatusDesc }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="“正常”项数量" prop='normalNum' align="left" min-width='100'
                    :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        {{ renderRowText(scope.row, scope.row.normalNum) }}
                    </template>
                </el-table-column>
                <el-table-column label="“异常”项数量" prop='abnormalNum' align="left" min-width='100'
                    :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        {{ renderRowText(scope.row, scope.row.abnormalNum) }}
                    </template>
                </el-table-column>
                <el-table-column label="“失败”项数量" prop='failureNum' align="left" min-width='100'
                    :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        {{ renderRowText(scope.row, scope.row.failureNum) }}
                    </template>
                </el-table-column>
                <el-table-column label="异常率" prop='abnormalRateDesc' align="left" min-width='100'
                    :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        {{ renderRowText(scope.row, scope.row.abnormalRateDesc) }}
                    </template>
                </el-table-column>
                <el-table-column label="分析时间" prop='detectTime' align="left" min-width='140'
                    :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        {{ renderRowText(scope.row, scope.row.detectTime) }}
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" prop='createTime' align="left" min-width='140'
                    :show-overflow-tooltip='true'></el-table-column>
                <el-table-column label="操作" fixed="right" align="center" width="120">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" v-if="scope.row.detectId" @click="goCheckPage(scope.row, 'detail')">查看</el-button>
                        <el-button type="text" size="small" v-if="scope.row.detectStatus == 3" @click="goCheckPage(scope.row, 'record')">检测报告</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="total, sizes, prev, pager, next" :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize" :total="total" :current-page="pageIndex" @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle" style="padding-bottom:12px;"></el-pagination>
        </div>
    </div>
</template>

<script>
    import {getToken} from '@/utils'
export default {
    data() {
        return {
            moreSearchItem: false,

            form: {
                keywords: "",
                detectStatusList: [],
                daterange: [],
            },

            detectStatusOptions: [],

            tableMaxHeight: document.documentElement.clientHeight - 318,
            dataListLoading: false,
            pageSize: 10,//每页条数
            pageIndex: 1,//当前页
            total: 0,//总条数
            tableData: [],
        }
    },

    mounted() {
        this.getDataList();
        this.getDic("jg_detect_status");
    },

    methods: {
        renderRowText(row, text) {
            if (row.detectStatus == 3) {
                return text
            }
            return "/";
        },

        getDic(type) { // 获取字典
            this.$httpReq.get('/sys/dictData/getList?type=' + type).then(res => {
                if (res.data.code === '1') {
                    switch (type) {
                        case 'jg_detect_status': this.detectStatusOptions = res.data.data; break;
                    }
                }
            })
        },

        searchBtn(type) {
            this.pageIndex = 1;
            this.moreSearchItem = false;
            this.getDataList(type);
        },
        refresh() {
            this.pageIndex = 1;
            this.form.keywords = "";
            this.form.detectStatusList = [];
            this.form.daterange = [];
            this.moreSearchItem = false;
            this.getDataList()
        },

        getDataList(type) { // 获取列表数据
            this.dataListLoading = true;
            let filter = {
                ...this.form,
                startDetectTime: this.form.daterange?.[0] ? (this.form.daterange[0] + " 00:00:00") : undefined,
                endDetectTime: this.form.daterange?.[1] ? (this.form.daterange[0] + " 23:59:59") : undefined,
            }

            this.$httpReq.post('/detect/tenderDocDetect/list', {
                'page': this.pageIndex,
                'rows': this.pageSize,
                'searchKey': this.form.keywords,
                'orderBy': "",
                'filter': type == "more" ? filter : {},
            }).then(res => {
                this.tableData = res.data.rows;
                this.total = res.data.total;
                this.$refs.multipleTable.doLayout();
                this.dataListLoading = false;
            })
        },
        indexMethod(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1
        },

        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1
            this.getDataList()
        },
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        dialogCancel() {
            this.moreSearchItem = false
        },

        goCheckPage(row, type) {
            let aiBaseURL = process.env.VUE_APP_BIDDING_DOCS_AI || '/bidding-docs-ai';
            let token = getToken();
            if (type == 'detail') {
                window.open(`${aiBaseURL}/deepseek/detail?checkId=${row.detectId||''}`)
            } else if (type == 'record') {
                window.open(`${aiBaseURL}/deepseek/record?checkId=${row.detectId||''}&testVersionCode=${row.detectVersion||''}`)
            }
        },
    },
}
</script>
<style lang="scss">
.content {
    .centerSearch {

        .el-input .el-input__inner,
        .el-input--medium .el-input__inner,
        .el-input--suffix .el-input__inner {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }

        .rightSearchBtn {
            height: 40px;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }

        .height_four {
            height: 40px;
        }

        .el-input--medium .el-input__inner {
            height: 40px;
            line-height: 40px;
        }
    }
}
</style>
<style lang="scss" scoped>
.mainBtn {
    padding: 16px;
}

.content {
    .centerSearch {
        width: calc(100% - 162px);
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        align-self: center;
    }

    .search-content {
        padding: 24px;
        display: flex;
        align-items: center;

        .pageTitle {
            font-size: 18px;
            font-weight: 600;
            color: #000000;
            height: 40px;
        }

    }

    .search-content>div {
        line-height: normal;
        padding: 0;
    }

}
</style>
